import React from 'react'

import dayjs from 'dayjs'

import { InactiveStudent } from './utils'
import { useCupons } from '../../../../../context'
import { Cupon, listHeads } from '../../../../../types'
import { Spacer } from '../../../../global'
import { TableContainer } from '../../../../lists/styles'

const AdminInactiveStudentsList = ({
  studensList,
}: {
  studensList: InactiveStudent[] | null
}) => {
  const { cupons } = useCupons()

  const getLastBono = (studentId: string) => {
    console.log(
      cupons.find((cupon: Cupon) => cupon.idStudent === studentId),
      'studentId',
    )
    return cupons.find((cupon: Cupon) => cupon.idStudent === studentId)
  }

  return (
    <TableContainer>
      <div className="t-row t-head bonus-list debt">
        {listHeads.inactiveStudents.map((item, i) => {
          return <div key={i}>{item}</div>
        })}
      </div>
      <Spacer height={10} />
      {studensList &&
        studensList.map((student, i) => {
          const bono = getLastBono(student.uid)
          console.log(bono, 'bono')

          return (
            <div className="t-row bonus-list" key={i}>
              <div className="with-image">
                <div
                  className="profile-image"
                  style={{
                    backgroundImage: `url(${student.image || '/assets/profile.png'})`,
                  }}
                ></div>
                {student.name} {student.lastname}
              </div>

              <div>
                {bono?.amountOfClasses
                  ? `${bono?.amountOfClasses} clases`
                  : '--'}{' '}
              </div>
              <div style={{ color: '#08A8D2', fontWeight: 600 }}>
                {bono?.attendance || '--'}
              </div>
              <div className="red">
                {bono?.dueDate
                  ? `Vencio: ${dayjs(bono?.dueDate).format('DD/MM/YYYY')}`
                  : '--'}
              </div>

              <div style={{ color: '#313131' }}>
                {student.lastLog ? student.lastLog : 'No ha realizado clases'}
              </div>
            </div>
          )
        })}
    </TableContainer>
  )
}

export default AdminInactiveStudentsList
